module.exports = __webpack_public_path__ + "static/media/ic_arrow_downward_48px.c889d84d.svg";